module.exports = new __parcel__URL__("Recent.d6a38253.svg").toString();